import { UserRoles } from '../../../../types/models/user/user.types';

export interface RegisterStepsProps {
  variant: UserRoles;
}

// RegisterStepsList's keys to be modified
export enum RegisterStepsList {
  SignUp = 'signup',
  Entity = 'entity',
  Company = 'company',
  User = 'user',
  Employees = 'employees',
  Documents = 'documents',
  Confirmation = 'confirmation',
  Pending = 'pending',
  Terminated = 'terminated',
}

export type RegisterData = {
  [Role in Partial<UserRoles>]: Partial<{
    [Step in Partial<RegisterStepsList>]: {
      component: () => JSX.Element;
      path: string;
    };
  }>;
};

export type RegisterDataObj = {
  component: () => JSX.Element;
  path: string;
};
